<template>
  <div class="account-information">
    <form
      action="#"
      novalidate
    >
      <div class="left">
        <div class="form-input-container">
          <ScLabel>
            <div class="name-label-wrapper">
              <div>
                <span>{{ $t('account.labels.name') }}</span>
                <ScTooltip
                  class="info-tooltip"
                >
                  <template #tooltip-trigger>
                    <GIcon
                      name="info"
                      stroke="var(--dark-grey-500)"
                      size="14px"
                      class="info-icon"
                    />
                  </template>
                  <template #tooltip-text>
                    {{ $t('account.tooltipTexts.sellerName') }}
                  </template>
                </ScTooltip>
              </div>
              <span
                v-if="editable"
                class="update-btn"
                @click="showSellerNameChangeModal=true"
              >
                Güncelle
              </span>
            </div>
          </ScLabel>
          <div class="input-container">
            <ScInput
              class="form-input"
              v-model="name"
              :disabled="true"
            />
          </div>
        </div>
        <div class="form-input-container">
          <ScLabel>{{ $t('account.labels.sellerId') }}</ScLabel>
          <div class="input-container">
            <ScInput
              class="form-input"
              v-model="sellerId"
              :disabled="true"
            />
          </div>
        </div>
        <div class="form-input-container">
          <div>
            <ScLabel>{{ $t('account.labels.taxOffice') }}</ScLabel>
            <ScTooltip
              class="info-tooltip"
            >
              <template #tooltip-trigger>
                <GIcon
                  name="info"
                  stroke="var(--dark-grey-500)"
                  size="14px"
                  class="info-icon"
                />
              </template>
              <template #tooltip-text>
                {{ $t('account.tooltipTexts.refetchUpdate') }}
              </template>
            </ScTooltip>
          </div>
          <div class="input-container">
            <ScInput
              class="form-input"
              v-model="taxOffice"
              :disabled="true"
            />
          </div>
        </div>
        <div class="form-input-container">
          <ScLabel>{{ $t('account.labels.taxOfficeNo') }}</ScLabel>
          <div class="input-container">
            <ScInput
              class="form-input"
              v-model="taxOfficeNo"
              :disabled="true"
            />
          </div>
        </div>
      </div>

      <div class="right">
        <div class="form-input-container">
          <div class="name-label-wrapper">
            <ScLabel>{{ $t('account.labels.currentAccountName') }}</ScLabel>
            <span
              v-if="editable && isMaster"
              class="update-btn"
              @click="onReFetchGibDetailModal"
            >
              Güncelle
            </span>
          </div>
          <div class="input-container">
            <ScInput
              class="form-input"
              v-model="currentAccountName"
              :disabled="true"
            />
          </div>
        </div>
        <div class="form-input-container">
          <ScLabel>
            <div class="name-label-wrapper">
              <div>
                <span>
                  {{ $t('account.labels.mersisNo') }}
                </span>
                <ScTooltip
                  class="info-tooltip"
                >
                  <template #tooltip-trigger>
                    <GIcon
                      name="info"
                      stroke="var(--dark-grey-500)"
                      size="14px"
                      class="info-icon"
                    />
                  </template>
                  <template #tooltip-text>
                    <p
                      class="tooltip-text-wrapper"
                      v-html="$t('account.tooltipTexts.mersisNo')"
                    />
                  </template>
                </ScTooltip>
              </div>

              <span
                v-if="editable"
                class="update-btn"
                @click="showUpdateFieldModal(mersisNo,'mersisNo')"
              >
                Güncelle
              </span>
            </div>
          </ScLabel>
          <div class="input-container">
            <input
              class="form-input form-control"
              v-model="mersisNo"
              v-mask="masks.mersisNo"
              :disabled="true"
            >
          </div>
        </div>
        <div class="form-input-container">
          <ScLabel>
            <div class="name-label-wrapper">
              <div>
                <span>
                  {{ $t('account.labels.kepAddress') }}
                </span>
                <ScTooltip
                  class="info-tooltip"
                >
                  <template #tooltip-trigger>
                    <GIcon
                      name="info"
                      stroke="var(--dark-grey-500)"
                      size="14px"
                      class="info-icon"
                    />
                  </template>
                  <template #tooltip-text>
                    <p
                      class="tooltip-text-wrapper"
                      v-html="$t('account.tooltipTexts.kepAddress')"
                    />
                  </template>
                </ScTooltip>
              </div>
              <span
                v-if="editable"
                class="update-btn"
                @click="showUpdateFieldModal(kepAddress,'kepAddress')"
              >
                Güncelle
              </span>
            </div>
          </ScLabel>

          <div class="input-container">
            <ScInput
              class="form-input"
              v-model="kepAddress"
              :disabled="true"
            />
          </div>
        </div>
      </div>
    </form>
    <GBox
      :mt="20"
      v-if="canShowContractHistory"
    >
      <ContractHistory />
    </GBox>
    <SellerNameModal
      @submit="onChangeSellerName"
      :show="showSellerNameChangeModal"
      @close="showSellerNameChangeModal=false"
      :data="{name}"
    />
    <UpdateFieldModal
      v-if="updateFieldModalData.show"
      v-bind="updateFieldModalData"
      @submit="onUpdateFieldModalSubmit"
      @close="hideUpdateFieldModal"
    />
    <ReFetchGibDetailModal
      :is-show="showReFetchGibDetailModal"
      @close="onReFetchGibDetailModalClose"
      @submit="onReFetchGibDetail"
    />
  </div>
</template>

<script>

import ScInput from '@trendyol/sc-ui-kit/ScInput';
import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import ScTooltip from '@trendyol/sc-ui-kit/ScTooltip';
import account from '@/services/account';
import SellerNameModal from '@/components/Info/Modals/SellerNameModal';
import ScEventBus from '@/services/ScEventBus';
import SupplierService from '@/services/SupplierService';
import { KEP_ADDRESS_REGEX } from '@/constants';
import UpdateFieldModal from '@/components/Info/Modals/UpdateFieldModal';
import GIcon from '@trendyol-js/grace/core/GIcon';
import GBox from '@trendyol-js/grace/core/GBox';
import ContractHistory from '@/components/Info/AccountInformation/ContractHistory';
import { remoteConfig } from '@/services';
import ReFetchGibDetailModal from '@/components/Info/AccountInformation/ReFetchGibDetailModal';

export default {
  name: 'AccountInformation',

  components: {
    ReFetchGibDetailModal,
    ContractHistory,
    UpdateFieldModal,
    SellerNameModal,
    ScInput,
    ScLabel,
    ScTooltip,
    GIcon,
    GBox,
  },

  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      accountInformation: {},
      showSellerNameChangeModal: false,
      showReFetchGibDetailModal: false,
      name: '',
      currentAccountName: '',
      sellerId: '',
      taxOffice: '',
      taxOfficeNo: '',
      mersisNo: '',
      kepAddress: '',
      validationRules: {
        mersisNo: { mersisNo: true, required: true },
        kepAddress: { regex: KEP_ADDRESS_REGEX, required: true },
      },
      masks: {
        mersisNo: '9999-9999-9999-9999',
      },
      updateFieldModalData: {
        show: false,
        value: '',
        name: '',
        title: '',
        label: '',
        placeholder: '',
        validation: {},
        mask: '',
      },
    };
  },

  computed: {
    canShowContractHistory () {
      return SupplierService.isMaster();
    },
    isNewSellerApi () {
      return remoteConfig.getConfigValueByKey('IS_NEW_SELLER_API', false);
    },
    isMaster () {
      return SupplierService.isMaster();
    },
  },

  created () {
    this.getAccountInformation();
  },
  methods: {
    onReFetchGibDetailModal () {
      this.showReFetchGibDetailModal = true;
      this.$gtm.trackEvent({
        event: 'GAEvent',
        eventCategory: 'Onboarding - Hesabım',
        eventAction: 'Cari Ünvanı Güncelle',
        eventLabel: SupplierService.getSupplierId(),
      });
    },
    onReFetchGibDetailModalClose () {
      this.showReFetchGibDetailModal = false;

      this.$gtm.trackEvent({
        event: 'GAEvent',
        eventCategory: 'Onboarding - Hesabım',
        eventAction: 'Cari Ünvanı Güncelle Vazgeç',
        eventLabel: SupplierService.getSupplierId(),
      });
    },
    async onReFetchGibDetail () {
      await account.reFetchGibDetail();

      this.$toast.success(this.$t('account.asyncSuccessToast'), {
        duration: 5000,
      });
      this.showReFetchGibDetailModal = false;
      this.$gtm.trackEvent({
        event: 'GAEvent',
        eventCategory: 'Onboarding - Hesabım',
        eventAction: 'Cari Ünvanı Güncelle Onay',
        eventLabel: SupplierService.getSupplierId(),
      });

      setTimeout(() => {
        this.getAccountInformation();
      }, 500);
    },
    hideUpdateFieldModal () {
      this.updateFieldModalData = {
        show: false,
        value: '',
        name: '',
        title: '',
        label: '',
        placeholder: '',
        validation: {},
        mask: '',
      };
    },
    async onUpdateFieldModalSubmit (value, name) {
      await this.updateMersisAndKep(value, name);

      this.hideUpdateFieldModal();

      setTimeout(() => {
        this.getAccountInformation();
        this.$toast.success(this.$t('account.asyncSuccessToast'));
      }, 600);
    },
    updateMersisAndKep (value, name) {
      const payload = this.getUpdateSellerInfoPayload({
        [name]: value,
      });

      return account.updateSellerInfo(payload);
    },
    showUpdateFieldModal (value, name) {
      this.updateFieldModalData = {
        value,
        name,
        title: this.$t(`account.updateFieldModalTitle.${name}`),
        label: this.$t(`account.labels.${name}`),
        placeholder: this.$t(`account.placeholder.${name}`),
        validation: this.validationRules[name],
        mask: this.masks[name],
        show: true,
      };
    },
    async onChangeSellerName ({ value }) {
      await this.updateSellerNameV2(value);

      this.showSellerNameChangeModal = false;

      await this.getAccountInformation({ name: value });

      this.$gtm.trackEvent({
        event: 'GAEvent',
        eventCategory: 'Onboarding - Hesabım',
        eventAction: 'Mağaza Adı Güncelle',
        eventLabel: SupplierService.getSupplierId(),
      });

      ScEventBus.publishEvent('SELLER_NAME_CHANGED', { value });
    },
    updateSellerNameV2 (value) {
      const payload = this.getUpdateSellerInfoPayload({
        sellerName: value,
        isSellerNameChanged: true,
      });

      return account.updateSellerInfo(payload);
    },
    getUpdateSellerInfoPayload (payload) {
      return {
        sellerName: this.accountInformation.sellerName,
        autoApprovable: this.accountInformation.autoApprovable,
        corporateType: this.accountInformation.corporateType,
        financialStatus: this.accountInformation.financialStatus,
        kepAddress: this.accountInformation.kepAddress,
        mersisNo: this.accountInformation.mersisNo,
        returnAccept: this.accountInformation.returnAccept,
        taxOffice: this.accountInformation.taxOffice,
        ...payload,
      };
    },

    async getAccountInformation ({ name } = {}) {
      const accountInformation = await account.getAccountInformationV2();

      this.accountInformation = accountInformation;
      this.name = name || accountInformation.sellerName;
      this.currentAccountName = accountInformation.companyName || '---';
      this.sellerId = accountInformation.sellerId.toString();
      this.taxOffice = accountInformation.taxOffice;
      this.taxOfficeNo = accountInformation.taxNumber;
      this.mersisNo = accountInformation.mersisNo;
      this.kepAddress = accountInformation.kepAddress;
    },
  },
};
</script>
<style scoped lang="scss">
  .account-information{
    form{
      display: flex;
      width: calc(66% + 30px);

      .left,.right{
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .right{
        margin-left: 30px;
      }
      .form-input-container {

        .name-label-wrapper {
          display: flex;
          justify-content: space-between;
        }

        .update-btn {
          font-weight: 500;
          font-size: 12px;
          color: #f27a1a;
          cursor: pointer;
          text-decoration: underline;
        }

        &:not(:last-child){
          margin-bottom: 16px;
        }

        ::v-deep .mp-label{
          font-size: 14px;
          .icon{
            margin-right: 0;
          }
        }

        .input-container{
          width: 100%;
          margin-top: 10px;
          display: flex;
          align-items: center;

          .form-input{
            width: 100%;
          }
        }
      }
      .button-container{
        display: flex;
        align-items: flex-end;
        .save-btn{
          margin-left: auto;
        }
      }
    }
    .info-icon {
      margin-left: 5px;
      cursor: pointer;
    }
    .tooltip-text-wrapper{
      &::v-deep {
        a {
          color: #f1f1f1;
          text-decoration: underline;
        }
      }
    }
    @media only screen and (max-width: 992px) {
      form {
        width: 100%;
      }
    }
    @media only screen and (max-width:767px) {
      form {
        flex-direction: column;

        .right{
          margin-left: unset;
          margin-top: 16px;
        }
      }

    }
  }

</style>
